import React from 'react'
import { Callout } from 'sutra/components/Callout/Callout'

/**
 * Banner shown on the catalog detail pane when the selected hierarchy has 0
 * feedback records. Sits above the (skipped) chart panels so customers who
 * onboarded a product see that Yogi is tracking it — before the first post
 * lands.
 */
export const TrackingEmptyBanner: React.FC = () => (
  <Callout variant="info">
    We&apos;re tracking this product, but there are no feedback records yet.
    Data will be updated here as it comes in.
  </Callout>
)
